module.exports = __webpack_public_path__ + "img/photo-3.c9da60e3.webp";